import { render, staticRenderFns } from "./PaginationText.vue?vue&type=template&id=76d5d9e0&scoped=true&"
import script from "./PaginationText.vue?vue&type=script&lang=js&"
export * from "./PaginationText.vue?vue&type=script&lang=js&"
import style0 from "./PaginationText.vue?vue&type=style&index=0&id=76d5d9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5d9e0",
  null
  
)

export default component.exports